import { DynamicDecorator } from '../../DynamicDecorator/DynamicDecorator';

export const DefaultDecorator = () => (
  <>
    <DynamicDecorator
      decorator="circle"
      className="text-naturaily-butterscotch absolute right-0 top-[calc(50%-20px)] hidden h-6 w-6 md:block"
    />
    <DynamicDecorator
      decorator="quadrant"
      className="text-primary-600 absolute right-16 top-[calc(50%+90px)] hidden h-6 w-6 md:block"
    />
    <DynamicDecorator
      decorator="quadrant"
      className="text-naturaily-airborne absolute left-10 top-[calc(50%-40px)] hidden h-6 w-6 md:block"
    />
    <DynamicDecorator
      decorator="quadrant"
      className="text-primary-600 absolute left-0 top-[calc(50%-100px)] hidden h-9 w-9 rotate-[-90deg] md:block"
    />
  </>
);
